import React from 'react';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import {Button, Col, Row} from 'reactstrap';
import {Fieldset} from 'primereact/fieldset';
import GeneralUtils from '../../shared/utils/GeneralUtils';
import PurchaseRequisitionService from '../../shared/service/PurchaseRequisitionService';
import DataTableWithButton from '../../shared/component/dataTable/DataTableWithButton';
import PurchaseRequisitionMobileColumn from '../../shared/component/dataTable/columns/PurchaseRequisitionMobileColumn.json';
import AvField from '../../shared/component/form/AvField';
import Loading from '../../shared/component/others/Loading';
import dayjs from 'dayjs';
import '../../shared/styles/SettingsPage.css';

const STATUS_FILTER_OPTIONS = [
    {name: 'All', value: ''},
    {name: 'Requisition', value: 'OPEN'},
    {name: 'Delivery Note', value: 'DELIVERY_NOTE'},
    {name: 'Return', value: 'RETURN'},
];

const STATUS_LABEL = {
    OPEN: 'Requisition',
    PURCHASE_ORDER: 'Purchase Order',
    DELIVERY_NOTE: 'Delivery Note',
    RETURN: 'Return',
    CLOSED: 'Closed'
};

export default class PurchaseRequisitionMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            requisitionList: [],
            allRequisitions: [],
            statusFilter: ''
        };
        this.purchaseRequisitionService = new PurchaseRequisitionService();
    }

    componentDidMount() {
        if (!GeneralUtils.isMobile()) {
            window.location.href = '#';
            return;
        }
        this.loadOpenRequisitions();
    }

    loadOpenRequisitions = () => {
        this.setState({loading: true});
        this.purchaseRequisitionService.findAllOpen().then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                const list = (response || []).map(item => ({
                    ...item,
                    createDate: item.createDate ? dayjs(item.createDate).format('DD/MM/YYYY') : '',
                    statusCode: item.requisitionStatus,
                    requisitionStatus: STATUS_LABEL[item.requisitionStatus] || item.requisitionStatus || '',
                    approved: item.approved === true || item.approved === 'true'
                }));
                this.setState({
                    allRequisitions: list,
                    loading: false
                }, () => this.applyStatusFilter());
            } else {
                this.setState({allRequisitions: [], requisitionList: [], loading: false});
            }
        }).catch(() => this.setState({loading: false}));
    };

    applyStatusFilter = () => {
        const {allRequisitions, statusFilter} = this.state;
        const filtered = !statusFilter
            ? allRequisitions
            : allRequisitions.filter(item => item.statusCode === statusFilter);
        this.setState({requisitionList: filtered});
    };

    __handleStatusFilterChange = (e) => {
        const value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState({statusFilter: value}, () => this.applyStatusFilter());
    };

    openNewRequisition = () => {
        window.location.href = '#purchaseRequisitionSaveMobile';
    };

    openNewDeliveryNote = () => {
        window.location.href = '#purchaseRequisitionSaveMobile?-1&mode=delivery';
    };

    onDataSelect = (data) => {
        if (data?.id) {
            window.location.href = '#purchaseRequisitionSaveMobile?' + data.id;
        }
    };

    render() {
        if (!GeneralUtils.isMobile()) {
            return null;
        }

        return (
            <div>
                <AvForm onSubmit={(e) => e.preventDefault()}>
                    <Fieldset legend="Purchase Requisition List">
                        <Row className="align-items-center" style={{marginBottom: '8px'}}>
                            <Col>
                                <AvGroup className="mb-2">
                                    <AvField
                                        type="select"
                                        className="form-control"
                                        name="statusFilter"
                                        value={this.state.statusFilter}
                                        onChange={this.__handleStatusFilterChange}
                                    >
                                        {STATUS_FILTER_OPTIONS.map(option => (
                                            <option value={option.value} key={option.name}>
                                                {option.name}
                                            </option>
                                        ))}
                                    </AvField>
                                </AvGroup>
                                <Button
                                    type="button"
                                    color="outline-primary"
                                    className="settings-page__btn--add"
                                    style={{width: '100%', minHeight: '32px', marginBottom: '6px'}}
                                    onClick={this.openNewRequisition}
                                >
                                    <i className="pi pi-plus" aria-hidden="true"/>
                                    Create Purchase Requisition
                                </Button>
                                <Button
                                    type="button"
                                    color="outline-primary"
                                    className="settings-page__btn--add"
                                    style={{width: '100%', minHeight: '32px'}}
                                    onClick={this.openNewDeliveryNote}
                                >
                                    <i className="pi pi-plus" aria-hidden="true"/>
                                    Create Delivery Note
                                </Button>
                            </Col>
                        </Row>

                        <DataTableWithButton
                            ref={(elem) => this.refDataTable = elem}
                            fields={PurchaseRequisitionMobileColumn.fields}
                            objectName={PurchaseRequisitionMobileColumn.name}
                            data={this.state.requisitionList}
                            selectionMode="single"
                            paginator={true}
                            rows={50}
                            onDataSelect={this.onDataSelect}
                            loading={this.state.loading}
                        />
                    </Fieldset>
                </AvForm>
                {this.state.loading && <Loading/>}
            </div>
        );
    }
}
